import { Box, Typography, Paper } from '@mui/material';
import LicenseeVaultLogo from '@/app/theme-layouts/shared-components/LicenseeVaultLogo';

function VaultCreatedConfirmationPage() {
  return (
    <div className='flex flex-col flex-auto items-center sm:justify-center min-w-0'>
      <Paper className='flex items-center w-full sm:w-auto min-h-full sm:min-h-auto rounded-0 py-32 px-16 sm:p-48 sm:rounded-2xl sm:shadow'>
        <div className='w-full max-w-360 sm:w-320 mx-auto sm:mx-0'>
          <Box className='flex justify-center'>
            <LicenseeVaultLogo />
          </Box>
          <Typography className='mt-32 text-2xl font-extrabold tracking-tight leading-tight text-center'>
            Thank you for your submission! Your information has been received. For any questions,
            please contact your advisor.
          </Typography>
        </div>
      </Paper>
    </div>
  );
}

export default VaultCreatedConfirmationPage;
